import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import '@/assets/less/reset.less'
import '@/assets/less/style.less'
import '@/iconfont/iconfont.css'
import VueI18n from "vue-i18n";
import i18n from './utils/locales/index'
import 'swiper/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

console.log(VueI18n)
Vue.config.productionTip = false;
Vue.use(VueI18n) // vue使用vue-i18n
const dashboardFlexible = require('lib-flexible-for-dashboard');
dashboardFlexible.init(16/9)

new Vue({
    router,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
